/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */

import React, { useEffect, useRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {
    array, string, number, bool,
} from 'prop-types';
import { useUIDSeed } from 'react-uid';
import Slider from 'react-slick';
import GraphqlPDPAltImageSliderV2 from '../GraphqlClubSelectionV2/ClubPDPAltImageSliderV2';

const useStyles = makeStyles((theme) => ({
    carouselContainer: {
        position: 'relative',
        width: '100%',
        overflow: 'hidden',
        '& .slick-list': {
            overflow: 'hidden',
            width: '90%',
            margin: '0 auto',
        },
        '& .slick-track': {
            display: 'flex',
            flexDirection: 'row',
            flexWrap: 'wrap',
            overflow: 'hidden',
        },
        '& .slick-slide': {
            display: 'inline-block',
            verticalAlign: 'middle',
            overflow: 'hidden',
            padding: '0 5px',
        },
        '& .slick-prev, & .slick-next': {
            cursor: 'pointer',
            border: 'none',
            outline: 0,
            fontSize: 0,
            top: '40%',
            backgroundColor: 'rgba(255, 255, 255, 0)',
            boxSizing: 'border-box',
            color: theme.palette.desktopHeaderMenu?.text || '#333333',
            width: '6%',
            position: 'absolute',
            zIndex: '9',
            '& svg': {
                height: 'inherit',
            },
        },
        '& .slick-prev': {
            left: '-6px',
            transform: 'rotate(90deg)',
        },
        '& .slick-next': {
            right: '-6px',
            transform: 'rotate(-90deg)',
        },
        '& .slick-disabled': {
            cursor: 'not-allowed',
            opacity: '0.5',
        },
    },
    flexCenter: {
        display: 'flex',
        justifyContent: 'center',
    },
    wrapper: {
        '& .slick-list': {
            width: '100%',

        },
    },
}));

const ClubPDPAltImageSlider = ({
    data, style, itemsPerSlide, itemsToShow, prevArrow, nextArrow, isClubPDPV2,
}) => {
    const classes = useStyles();
    const sliderRef = useRef();
    const seed = useUIDSeed();
    useEffect(() => {
        if (sliderRef?.current) {
            sliderRef.current.slickGoTo(0);
        }
    }, [data]);
    if (isClubPDPV2) {
        return (
            <GraphqlPDPAltImageSliderV2
                data={data}
                style={style}
                itemsPerSlide={itemsPerSlide}
                itemsToShow={itemsToShow}
            />
        );
    }
    return (
        <div className={classes.flexCenter} key={seed(data)} data-testId="altImage_slider">
            <Slider
                dots={false}
                speed={500}
                infinite={false}
                slidesToShow={itemsToShow}
                slidesToScroll={itemsPerSlide}
                ref={sliderRef}
                nextArrow={<img alt="Next Link" src={nextArrow} />}
                prevArrow={<img alt="Previous Link" src={prevArrow} />}
                variableWidth={!data.length > 2}
                className={`carousel-container ${classes.carouselContainer} ${style} ${data.length < 5 ? classes.wrapper : ''}`}
            >
                {data.map((item) => (
                    <div key={seed(item)}>
                        { item }
                    </div>
                ))}
            </Slider>
        </div>
    );
};
ClubPDPAltImageSlider.propTypes = {
    data: array,
    style: string,
    nextArrow: string.isRequired,
    prevArrow: string.isRequired,
    itemsToShow: number,
    itemsPerSlide: number,
    isClubPDPV2: bool,
};
ClubPDPAltImageSlider.defaultProps = {
    data: [],
    style: '',
    itemsToShow: 4,
    itemsPerSlide: 4,
    isClubPDPV2: false,
};
export default ClubPDPAltImageSlider;
